export const subscribe = (behaviorSubjectKey) => (target, propertyKey) => {
    const targetPrototype = target.constructor;
    targetPrototype.addInitializer(instance => {
        instance.subscribeField(propertyKey, behaviorSubjectKey);
        //   const subjectKey = behaviorSubjectKey ?? propertyKey;
        //   const subject = GlobalReactiveXStores.getBehaviorSubject(subjectKey);
        //   const rxElement = instance as T;
        //   const subscription = subject.subscribe(val => {
        //     rxElement[propertyKey] = val as any;
        //   });
        //   rxElement.trackSubscription(subscription);
    });
};
//# sourceMappingURL=rxElementDecorators.js.map